import mapboxgl from 'mapbox-gl';
import MapboxDraw from '@mapbox/mapbox-gl-draw';
import API from '@/services/API.js';
import Auth from '@/services/auth.js';

export default {

    TYPES: {
        ROOT: 'root',
        SITE: 'site',
        GROUP: 'group',
        BUILDING: 'building',
        FLOOR: 'floor',
        PLAN: 'plan',
    },

    MAP_TYPES: {
        INDOOR: 'indoor',
        OUTDOOR: 'outdoor',
        MINI: 'mini',
    },

    MAP_CONFIGS: {
        'global': {
            logoPosition: 'top-left',
            attributionControl: false
        },
        'outdoor': {
            //style: 'mapbox://styles/mapbox/satellite-streets-v9',
            style: 'mapbox://styles/mapbox/streets-v12',
            center: [1.87635, 46.60559],
            zoom: 5,
            maxZoom: 22
        },
        'indoor': {
            style: 'mapbox://styles/suivideflotte/cj3fl8ute00002rl6fy4pfv8q',
            center: [0, 0],
            zoom: 9,
            maxZoom: 10
        }
    },

    accessToken: 'pk.eyJ1Ijoic3VpdmlkZWZsb3R0ZSIsImEiOiJjajNjeGU3cDIwMDB3MndxZWdzYWF0NXRyIn0.Iprcn2cLeTk1z9sCMGOiAA',

    init: function (id, mapType, center, zoom, pitching) {
        mapboxgl.accessToken = this.accessToken;

        var config = {
            container: id
        };

        if (pitching == null) {
            pitching = false;
        }

        if (center != null) {
            config.center = center;
        }
        if (zoom != null) {
            config.zoom = zoom;
        }

        var map = new mapboxgl.Map(Object.assign(this._getMapConfig('global'), this._getMapConfig(mapType),
            config
        ));

        map.dragRotate._pitchWithRotate = pitching;

        map.addControl(new mapboxgl.AttributionControl(), 'bottom-left');

        map.addControl(new mapboxgl.NavigationControl());


        /**/

        return map;
    },

    activate: function (map) {
        map.boxZoom.enable();
        map.doubleClickZoom.enable();
        map.dragPan.enable();
        map.dragRotate.enable();
        map.keyboard.enable();
        map.scrollZoom.enable();
        map.touchZoomRotate.enable();
    },

    deactivate: function (map) {
        map.boxZoom.disable();
        map.doubleClickZoom.disable();
        map.dragPan.disable();
        map.dragRotate.disable();
        map.keyboard.disable();
        map.scrollZoom.disable();
        map.touchZoomRotate.disable();
    },

    getBounds: function (coordinates, marginSpe) {



        var minLng = parseFloat(coordinates[0][0]),
            maxLng = 0,
            minLat = parseFloat(coordinates[0][1]),
            maxLat = 0,
            margin = 0.0001;

        if(marginSpe){
            margin = marginSpe;
        }

        if(coordinates.length == 1){
            return [[minLng - margin, minLat - margin], [minLng + margin, minLat + margin]];
        }

        for (var i = 0; i < coordinates.length; i++) {
            if (parseFloat(coordinates[i][0]) < minLng) {
                minLng = parseFloat(coordinates[i][0]);
            } else if (parseFloat(coordinates[i][0]) > maxLng) {
                maxLng = parseFloat(coordinates[i][0]);
            }

            if (parseFloat(coordinates[i][1]) < minLat) {
                minLat = parseFloat(coordinates[i][1]);
            } else if (parseFloat(coordinates[i][1]) > maxLat) {
                maxLat = parseFloat(coordinates[i][1]);
            }
        }


        return [[minLng - margin, minLat - margin], [maxLng + margin, maxLat + margin]];
    },

    _getMapConfig: function (mapType) {
        return this.MAP_CONFIGS[mapType];
    },

    utils: {}

}
